import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"items":_vm.assignmentList,"item-value":"id","item-text":"projectName","label":"Assignment","clearable":true,"disabled":true},model:{value:(_vm.assignmentIdValue),callback:function ($$v) {_vm.assignmentIdValue=$$v},expression:"assignmentIdValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }